import { observable, action } from 'mobx'
import { has } from 'lodash'

export interface IStudioConfig {
  transport?: 'http' | 'electron' // Controls how communication with the backend will happen
  readonly?: boolean // Enables / Disables Action commits to the DB
  updates?: boolean // Enables / Disables update checks
  headerLeftOffset?: number // Number of pixels to leave empty on the left side of the header (macOS renders its traffic lights here)
  isBrowser?: boolean // Enables / Disables browser specific features
}

class ConfigStore {
  @observable transport: IStudioConfig['transport'] = 'http'
  @observable readonly: IStudioConfig['readonly'] = false
  @observable updates: IStudioConfig['updates'] = false
  @observable headerLeftOffset: IStudioConfig['headerLeftOffset'] = 32 // 32 because we do not want the header to stick to the left side of the screen if ignored
  @observable isBrowser: IStudioConfig['isBrowser'] = true

  @action
  update(config: Partial<IStudioConfig>) {
    has(config, 'transport') && (this.transport = config.transport!)
    has(config, 'readonly') && (this.readonly = config.readonly!)
    has(config, 'updates') && (this.updates = config.updates!)
    has(config, 'headerLeftOffset') &&
      (this.headerLeftOffset = config.headerLeftOffset!)
    has(config, 'isBrowser') && (this.isBrowser = config.isBrowser!)
  }
}

export default new ConfigStore()
